import { playSoundWithRate } from '@/src/utils/soundPlayer'

const SEQUENCE_BREAK_MS = 1000
const RATE_STEP = 1.1

let lastCollectedAt = 0
let sequenceIndex = 0

export function resetCoinCollectSequence(): void {
    lastCollectedAt = 0
    sequenceIndex = 0
}

export function playCoinCollectSound(): number | null {
    const now = performance.now()

    if (lastCollectedAt === 0 || now - lastCollectedAt > SEQUENCE_BREAK_MS) {
        sequenceIndex = 0
    } else {
        sequenceIndex += 1
    }

    lastCollectedAt = now

    const rate = RATE_STEP ** sequenceIndex
    return playSoundWithRate('coinCollect', rate)
}
